import { empApi } from "./client";

// Serialize query — mảng lặp key (employeeIds=a&employeeIds=b) để backend (qs) parse thành mảng.
// Bỏ qua undefined/null/"".
const buildQuery = (path, params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (Array.isArray(v)) v.forEach((x) => x != null && usp.append(k, x));
    else usp.append(k, v);
  });
  const qs = usp.toString();
  return qs ? `${path}?${qs}` : path;
};

// Tổng quan CCMG của tôi
export const getMyBdcApi = () => empApi.get("/brokerDebtCertificate/app/my");

// Người thân (CTV) của tôi + 4 chỉ số CCMG từng người & mục Tổng -> { items, total }
export const getMyBdcRelativesApi = () =>
  empApi.get("/brokerDebtCertificate/app/my/relatives");

// Danh sách đợt tạm giữ CCMG -> { items, pagination }
// Nhận employeeId (đơn) hoặc employeeIds (mảng gộp cá nhân + CTV).
export const getBdcPeriodListApi = (params) =>
  empApi.get(buildQuery("/brokerDebtCertificate/period-list", params));

// Lịch sử thanh toán CCMG -> { items, pagination }
// Nhận employeeId (đơn) hoặc employeeIds (mảng gộp cá nhân + CTV).
export const getBdcDisbursementListApi = (params) =>
  empApi.get(buildQuery("/brokerDebtDisbursement/app", params));
